(function(){
  'use strict';
  var body=document.body;
  var drawer=document.querySelector('[data-mt-drawer]');
  var search=document.querySelector('[data-mt-search]');

  function setLocked(){body.classList.toggle('is-locked',!!((drawer&&drawer.classList.contains('is-open'))||(search&&search.classList.contains('is-open'))));}
  function openDrawer(){if(!drawer)return;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');setLocked();var x=drawer.querySelector('[data-mt-menu-close]');if(x)x.focus();}
  function closeDrawer(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');setLocked();}
  function openSearch(){if(!search)return;search.classList.add('is-open');search.setAttribute('aria-hidden','false');setLocked();var input=search.querySelector('[data-mt-search-input]');if(input)setTimeout(function(){input.focus();},30);}
  function closeSearch(){if(!search)return;search.classList.remove('is-open');search.setAttribute('aria-hidden','true');setLocked();}

  document.querySelectorAll('[data-mt-menu-open]').forEach(function(el){el.addEventListener('click',openDrawer);});
  document.querySelectorAll('[data-mt-menu-close]').forEach(function(el){el.addEventListener('click',closeDrawer);});
  document.querySelectorAll('[data-mt-search-open]').forEach(function(el){el.addEventListener('click',openSearch);});
  document.querySelectorAll('[data-mt-search-close]').forEach(function(el){el.addEventListener('click',closeSearch);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();closeSearch();}});

  var back=document.querySelector('[data-mt-backtop]');
  if(back){
    function updateBack(){back.classList.toggle('is-visible',window.scrollY>650);}
    updateBack();window.addEventListener('scroll',updateBack,{passive:true});
    back.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
  }
})();
